import PropTypes from 'prop-types'
import React from 'react'
import ContactInfoForm from './ContactInfoForm'
import UpdateContactList from './UpdateContactList'

const ContactPopover = ({
  popoverPage,
  newContactInfo,
  onChangeContactInfo,
  onDropdownSelect,
  onDiscardClick,
  onSaveClick,
  onBackClick,
  matchingContacts,
  handleExistingContactClick,
  handleNewContactClick,
}) => {
  switch (popoverPage) {
    case 'enterContactInfo': {
      return (
        <ContactInfoForm
          newContactInfo={newContactInfo}
          onChangeContactInfo={onChangeContactInfo}
          onDropdownSelect={onDropdownSelect}
          onDiscardClick={onDiscardClick}
          onSaveClick={onSaveClick}
        />
      )
    }
    case 'updateContact': {
      return (
        <UpdateContactList
          matchingContacts={matchingContacts}
          handleExistingContactClick={handleExistingContactClick}
          handleNewContactClick={handleNewContactClick}
          onDiscardClick={onDiscardClick}
          onBackClick={onBackClick}
        />
      )
    }
    default: {
      return null
    }
  }
}

ContactPopover.propTypes = {
  popoverPage: PropTypes.string.isRequired,
  newContactInfo: PropTypes.object.isRequired,
  onChangeContactInfo: PropTypes.func.isRequired,
  onDropdownSelect: PropTypes.func.isRequired,
  onDiscardClick: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  matchingContacts: PropTypes.array.isRequired,
  handleExistingContactClick: PropTypes.func.isRequired,
  handleNewContactClick: PropTypes.func.isRequired,
}

export default ContactPopover



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactPopover/index.js